(() => {
  const roots = document.querySelectorAll('product-form[data-bt-preorder-shipping]');
  roots.forEach((root) => {
    const message = root.dataset.btPreorderShipping;
    if (!message) return;
    const synchronizeShippingCopy = () => {
      root.querySelectorAll('.preorder-detail-text').forEach((copy) => {
        if (/^\s*Shipping:\s*Late December\s*[-–]\s*Early January\s*$/i.test(copy.textContent)) {
          copy.textContent = message;
        }
      });
    };
    synchronizeShippingCopy();
    const observer = new MutationObserver(synchronizeShippingCopy);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  });
})();
